<template>
 <footer class= "d-flex justify-content-center ">
   <div id="contain" class= "d-flex justify-content-center justify-content-around align-items-center ">
     <div class ="titre">
            {{ title }} - version Alpha
     </div>      
         
    <div class="mode">
          Mode : {{ mode }}
    </div>
       <div class="droit">
            <span class="blueC2i">© C2i santé</span> | 2020 – Tous droits réservés
       </div>     
         
    </div>
  </footer>



</template>

<script>
  export default {
    name: 'Footer',
    props: {
      title: {
        type: String,
        default: process.env.VUE_APP_TITLE
      },
      mode: {
        type: String,
        default: process.env.NODE_ENV
      }
    }
  }
</script>

<style scoped>

  footer {
    
    background-color: #282828;
    width: 100vw;
    bottom: 0;
    position: fixed;
    font-size: 12px;
    color:white;
    z-index: 1000;
    height: 5vh;
  }

 
  .blueC2i{
    color: #009de0;
  }

  #contain{
    width:100%;
  }

 
  
</style>